import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GeneralsService {

  url:string = environment.apiUlr
  constructor( private httpC:HttpClient ) {  }


getVisits(){
  return this.httpC.get( `${this.url}/count_vist.php`);  
}

}
